import { Box } from "@mui/material";

import {
  BoZoneFocusCard,
  BoZoneNoticedCard,
  BoZoneScoreList,
  BoZoneTrendsCard,
  BoZoneWeekCard,
} from "../../layer21";
import { useAppSelector } from "utils/redux/hooks";
import { selectCurrentUserAccountId } from "app/containers/Global/slice";
import { useGetCheckInSummaryQuery } from "app/containers/TeamsTab/teamsCheckInApi";
import { skipToken } from "@reduxjs/toolkit/dist/query";

export const BoZoneActivityDetailSection = () => {
  const currentUserAccountId = useAppSelector(selectCurrentUserAccountId);
  const { data, isFetching } = useGetCheckInSummaryQuery(
    currentUserAccountId
      ? {
          userAccountId: currentUserAccountId,
          mostRecentCompletedCheckIn: true,
        }
      : skipToken
  );

  const checkInSummary = data?.checkInCompleted ? data : null;

  return (
    <Box
      display="flex"
      flexDirection="column"
      rowGap=".75rem"
      marginTop="1.5rem"
    >
      <BoZoneFocusCard userAccountId={currentUserAccountId} />
      <BoZoneScoreList checkInSummary={checkInSummary} />
      <BoZoneNoticedCard userAccountId={currentUserAccountId} />
      <BoZoneWeekCard
        checkInSummary={checkInSummary}
        isCheckInSummaryLoading={isFetching}
        hasPendingCheckIn={!!data?.hasPendingCheckIn}
      />
      <BoZoneTrendsCard
        userAccountId={currentUserAccountId}
        checkInSummary={checkInSummary}
        isCheckInSummaryLoading={isFetching}
      />
    </Box>
  );
};
